module.exports = __webpack_public_path__ + "static/3-667e0607683762a117b0d83f804d5e67.png";